import { render, staticRenderFns } from "./ServiceStrip.vue?vue&type=template&id=bd8a0c34&scoped=true&"
import script from "./ServiceStrip.vue?vue&type=script&lang=js&"
export * from "./ServiceStrip.vue?vue&type=script&lang=js&"
import style0 from "./ServiceStrip.vue?vue&type=style&index=0&id=bd8a0c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8a0c34",
  null
  
)

export default component.exports